export default __webpack_public_path__ + "static/sbanken-ab1a12b700797d06503e08152611429e.png";